<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <!-- Login -->
      <v-card light tile width="320" height="380">
        <v-system-bar window color="white" class="pl-0">
          <v-img :src="require('@/assets/img/favicon.png')" contain height="35" max-width="50"></v-img>
          <v-spacer></v-spacer>
        </v-system-bar>

        <v-card-title class="pb-0 justify-center">
          <h4>Battisti Mobile</h4>
        </v-card-title>

        <v-card-text class="pt-0">
          <v-form ref="formLogin" v-on:submit.prevent="login()">
            <v-text-field label="E-Mail" required v-model="cred.username" :rules="[
              () =>
                cred.username.length > 0 || 'Il campo utente è obbligatorio',
            ]" ref="inputMail" autofocus>
            </v-text-field>
            <v-text-field label="Password" required :type="showText ? 'text' : 'password'"
              :append-icon="showText ? 'visibility' : 'visibility_off'" @click:append="showText = !showText"
              v-model="cred.password" :rules="[
                () =>
                  cred.password.length > 0 || 'Il campo password è obbligatorio',
              ]"></v-text-field>

            <v-btn block type="submit" :disabled="attesaLogin" :loading="attesaLogin" color="primary" class="mt-4">
              Accedi
            </v-btn>
          </v-form>
        </v-card-text>

      </v-card>
    </v-layout></v-container>
</template>

<script>


export default {
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },

  },

  data: () => ({
    cred: {
      username: "",
      password: "",
    },

    attesaLogin: false,
    showText: false,
    autofocus: false,

    alertPwd: "",
    tipoAlert: "success",

    attesaMail: false,
  }),

  methods: {
    async login() {
      // Validazione
      if (this.$refs.formLogin.validate() == false) {
        return;
      }

      // Attesa  login
      this.attesaLogin = true;

      // Reset messaggi
      this.$toast.close();

      try {
        // Login
        await this.$store.dispatch("auth/login", this.cred);

        // Reset dati
        this.cred.username = "";
        this.cred.password = "";

        // Vado alla pagina riservata
        this.$router.push({ path: "/" });


      } catch (error) {
        this.$toast.warning(this.$functions.getErrorMsg(error));
      }

      // Fine attesa
      this.attesaLogin = false;

      return false;
    },


  },

};
</script>
